<div class="tree-node-container">
  <div
    class="header"
    [ngClass]="{active: isActive()}"
  >
    <button
      mat-icon-button
      type="button"
      (click)="toggleOpen();"
      [disabled]="isLeafNode() || node.is_leaf"
      [style.visibility]="alwaysExpanded || isLoading() || isLeafNode() || node.is_leaf"
    >
      @if (!node.is_leaf) {
        <mat-icon>
          {{ (open || alwaysExpanded) && !isLoading() && !isLeafNode() ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
      }
    </button>

    <div
      class="label"
      (click)="selectNode()"
      (keydown)="null"
    >
      <span
        [innerHTML]="(node?.label || '') | translate"
      ></span>

      <span
        class="secondary"
        [innerHTML]="(node?.secondaryLabel || '') | translate"
      ></span>
    </div>

    @if (showReloadButton || isLoading()) {
      <button
        mat-icon-button
        class="reload-button"
        type="button"
        color="accent"
        [disabled]="isLoading()"
        (click)="onReload.emit(node)"
      >
        <mat-icon [ngClass]="{loading: isLoading()}">
          refresh
        </mat-icon>
      </button>
    }
  </div>

  <div class="children-container" [ngClass]="{closed: !(alwaysExpanded || open) || isLeafNode()}">
    @for (child of getChildren(); track $index) {
      <app-tree-node
        [showReloadButton]="showReloadButton"
        [alwaysExpanded]="alwaysExpanded"
        [loading]="loading"
        [node]="child"
        [children]="children"
        [selected]="selected"
        (onReload)="onReload.emit($event)"
        (onSelect)="onSelect.emit($event)"
        (onOpen)="onOpen.emit($event)"
        (onClose)="onClose.emit($event)"
      ></app-tree-node>
    }
  </div>
</div>
